import React, { useEffect, useState } from 'react';
import BottomNav from '../../components/BottomNav';
import HeaderWithBack from '../../components/HeaderWithBack';
import HealthRecordList from './HealthRecordList';
import axios from '../../api/axios';
import Summary from './Summary';
import { group } from 'console';
import { FaRemoveFormat } from 'react-icons/fa';

interface HealthRecordProps {
  userId: string | null;
  username: string | null;
  conversationID: string;
  conversationType: number;
}

interface Summary {
  id: number;
  final_at: string;
  healthcare: string;
  doctor: string;
  speciality: string;
  subjective: string;
  objective: string;
  assessment: string;
  plan: string;
  date: string;
}

interface GroupedSummary {
  date: string;
  summaries: Summary[];
}

const HealthRecord: React.FC<HealthRecordProps> = ({ userId, username, conversationID, conversationType }) => {
  const [tab, setTab] = useState<'Diary' | 'My Family' | 'Care Team'>('Diary');
  const [healthRecord, setHealthRecord] = useState<GroupedSummary[]>([]);
  const [latestDate, setLatestDate] = useState<string | null>(null);

  const today = new Date();
  const hari = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const bulan = [
    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
  ];
  const dayName = hari[today.getDay()];
  const dayNumber = today.getDate();
  const monthYear = `${bulan[today.getMonth()]} ${today.getFullYear()}`;

  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('list-health-records', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const records = response.data?.data || [];
        const grouped: { [date: string]: Summary[] } = {};

        records.forEach((record: any) => {
          const teleconsult = record.teleconsult;
          const summarys: Summary[] = teleconsult?.summarys || [];

          const doctorName = record.practitioner_roles?.practitioner?.name || '';
          const hospitalName = record.practitioner_roles?.hospital?.name || '';
          const specialityName = record.practitioner_roles?.speciality?.name || '';

          summarys.forEach((summary: Summary) => {
            const date = summary.final_at?.split(' ')[0];
            if (!date) return;

            if (!grouped[date]) grouped[date] = [];

            grouped[date].push({
              ...summary,
              doctor: doctorName,
              healthcare: hospitalName,
              speciality: specialityName,
              date: summary.final_at,
            });
          });
        })

        const formatted: GroupedSummary[] = Object.entries(grouped)
          .sort((a, b) => new Date(b[0]).getTime() - new Date(a[0]).getTime())
          .map(([date, summaries]) => ({
            date, 
            summaries
          }));

        setHealthRecord(formatted);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
    fetchData();
  }, [token]);
  
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', minHeight: '100vh', paddingBottom: '60px' }}>
      <HeaderWithBack title="Health Record" />

      <div className="min-h-screen bg-gray-100 font-sans p-4 mb-2">
        <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg border border-gray-200 relative overflow-visible">
          <div className="flex bg-teal-400 text-white text-lg font-semibold">
            {(['Diary', 'My Family', 'Care Team'] as const).map((item) => (
              <button
                key={item}
                onClick={() => setTab(item)}
                className={`flex-1 p-4 ${tab === item ? 'bg-teal-500 border-b-4 border-white' : 'opacity-75'}`}
              >
                {item}
              </button>
            ))}
          </div>

          <div className="flex bg-gray-300 text-gray-700 px-4 py-2">
            <div className="text-4xl mt-1 font-bold leading-none">{dayNumber}</div>
            <div className="ml-4 flex flex-col justify-center">
              <div className="text-md capitalize">{dayName}</div>
              <div className="text-sm">{monthYear}</div>
            </div>
          </div>

          <div>
            {tab === 'Diary' ? (
              <HealthRecordList
                userId={userId}
                username={username}
                conversationID={conversationID}
                conversationType={conversationType}
                healthRecord={healthRecord}
              />
            ) : (
              <div className="mt-10 text-center text-gray-500">Tab "{tab}" belum diisi.</div>
            )}
          </div>
        </div>
      </div>


      <BottomNav />
    </div>
  );
};

export default HealthRecord;
